<template>
  <!--
      作者 luoyiming
      时间：2019-10-26
      描述：设置-商城设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">关于我们</div>
      <el-form-item label="关于我们" v-if="!loading">
        <div class="edit_container">
          <Uediter v-model="form.about" id="ue1" :text="form.about" :config="ueditor1.config" ref="ue1"></Uediter>
        </div>
      </el-form-item>

      <el-form-item label="隐私政策" v-if="!loading">
        <div class="edit_container">
          <Uediter v-model="form.privacy" id="ue2" :text="form.privacy" :config="ueditor2.config" ref="ue2"></Uediter>
        </div>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';
  import Uediter from '@/components/UE.vue';
  import { formatModel } from '@/utils/base.js';
  export default {
    components:{
      Uediter
    },
    data() {
      return {
        /*是否正在加载*/
        loading: true,
        /*form表单数据*/
        form: {
          about: '',        
          privacy: '',   
        },
        ueditor1: {
          text: '',
          config: {
            initialFrameWidth: 400,
            initialFrameHeight: 500
          }
        },
        ueditor2: {
          text: '',
          config: {
            initialFrameWidth: 400,
            initialFrameHeight: 500
          }
        },
      };
    },
    created() {
      this.getParams()
    },

    methods: {

      /*获取配置数据*/
      getParams() {
        let self = this;
        SettingApi.aboutDetail({}, true).then(res => {
            let vars = res.data.vars.values;
            self.form = formatModel(self.form, vars);

            self.form.about = vars.about || self.form.about;
            self.form.privacy = vars.privacy || self.form.privacy;
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;   
          });
      },


      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.form;
        params.about = this.$refs.ue1.getUEContent();
        params.privacy = this.$refs.ue2.getUEContent();

        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            SettingApi.editAbout(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，关于我们设置成功',
                  type: 'success'
                });
                self.$router.push('/setting/about/index');
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },
    }

  };
</script>
<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/about/index.vue